import { render, staticRenderFns } from "./iframeVedio.vue?vue&type=template&id=9dbbb0c4&scoped=true"
import script from "./iframeVedio.vue?vue&type=script&lang=js"
export * from "./iframeVedio.vue?vue&type=script&lang=js"
import style0 from "./iframeVedio.vue?vue&type=style&index=0&id=9dbbb0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbbb0c4",
  null
  
)

export default component.exports